export const trimLanguage = (language) => {
    return language.replace(/ \(.+\)$/, '');
};
